import { useEffect } from "react";
import { useEditorContext } from "../EditorContext";

export default function SubmitPlugin() {
	const { editor, sendDisabled, setSendDisabled, submitEditor } = useEditorContext();

	useEffect(() => {
		return editor.registerUpdateListener(({ editorState }) => {
			editorState.read(() => {
				const text = $getRoot().getTextContent().trim();
				setSendDisabled(text.length === 0);
			});
		});
	}, [editor]);

	useEffect(() => {
		return editor.registerCommand(
			KEY_ENTER_COMMAND,
			(event) => {
				// If Shift+Enter, allow submission

				if (!event.shiftKey || sendDisabled) {
					return false; // let Lexical handle it
				}

				event.preventDefault(); // avoid new line
				submitEditor();
				return true; // stop Lexical’s default behavior
			},
			COMMAND_PRIORITY_HIGH
		);
	}, [editor, handleSubmit, sendDisabled]);

	return null; // this plugin does not render anything
}
